<template>
    <div class="equipment_management">
      <div class="search">
        <div class="search_box">
          <div v-for="item in search" :class='["search_options_box"]'>
            <span style="width: 100px;">{{item.title}}</span>
            <el-select class="select" v-model="selectValue" placeholder="请选择项目" @change="getSelectProject(selectValue )">
              <el-option v-for="item2 in item.options" :label="item2.label" :value="item2.value" :key="item2.value"></el-option>
            </el-select>
          </div>
          <div class="search_btn_box">
            <button :class='["search_btn","green","icon_btn","clearborder"]' @click="ListData()"><span class="el-icon-search"></span>查找</button>
          </div>
          <div class="add_btn_box">
            <button :class='["add_btn","delete","icon_btn","clearborder"]'><span class="el-icon-delete"></span>批量删除</button>
            <button :class='["add_btn","add","clearborder"]'  @click="addtrigger=!addtrigger"><span class="el-icon-plus"></span>添加任务</button>
          </div>
        </div>
      </div>
      <!--table-->
      <div class="table_content">
        <table>
          <thead>
          <tr>
            <th style="width: 50px !important;">
              <input type="checkbox" name="issue_all">
            </th>
            <th style="width: 100px !important;">启用</th>
            <th>任务名称</th>
            <th>状态</th>
            <th>触发器</th>
            <th>手动</th>
            <th>操作</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item,index) in data">
            <td style="width: 50px !important;">
              <input type="checkbox" name="issue">
            </td>
            <td style="width: 100px !important;">
              <el-switch
              v-model="item.isdisable"
              active-color="#13ce66"
              inactive-color="#a4a4a5"
              active-value="0"
              inactive-value="1"
              @change="openClose($event,item.id)" >
              </el-switch>
            </td>
            <td>{{item.name}}</td>
            <td>
              <span v-if="item.state=='0'">未运行</span>
              <span v-else="item.state=='1'">正在运行</span>
            </td>
            <td>
              <span v-if="item.timing=='0'">[定时]</span>
              <span>{{item.executionDate}}</span>
              <span v-if="item.cycleType=='0'">每天</span>
              <span v-else-if="item.cycleType=='1'">每周<span>({{item.week}})</span></span>
              <span v-else-if="item.cycleType=='2'">单次</span>
              <span>{{item.startDate}}</span>
              <span v-if="item.cycleType=='0'">至</span>
              <span v-else-if="item.cycleType=='1'">至</span>
              <span v-if="item.cycleType=='0'">{{item.endDate}}</span>
              <span v-else-if="item.cycleType=='1'">{{item.endDate}}</span>
            </td>
            <td>
              <el-switch
                v-model="item.state"
                active-color="#409eff"
                inactive-color="#a4a4a5"
                active-value="2"
                inactive-value="0"
                @change="handController($event,item.id)" >
              </el-switch>
            </td>
            <td class="table_btn">
              <button class="paly" style="margin-right: 20px" @click="loudEdit=!loudEdit,getTask(item.id)">修改</button>
              <button class="remove" @click="deleteTask(item.id)">删除</button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="table_paging">
        <p>当前记录<span>1</span>到<span>5</span>条，共<span>5</span>条记录
          <button
            v-bind:style="[{background:'url(/static/img/icon/table_start.png) no-repeat center center'}]"></button>
          <button
            v-bind:style="[{background:'url(/static/img/icon/table_prep.png) no-repeat center center'}]"></button>
          第<span>1</span>/<span>1</span>页
          <button
            v-bind:style="[{background:'url(/static/img/icon/table_next.png) no-repeat center center'}]"></button>
          <button
            v-bind:style="[{background:'url(/static/img/icon/table_end.png) no-repeat center center'}]"></button>
        </p>
      </div>
      <!--  添加任务-->
      <transition name="fade">
        <div class="mark" v-if="addtrigger">
          <div class="mark_close" @click="addtrigger=!addtrigger"></div>
          <div :class='["information_box","light_border","weather_box"]'
               :style="[{width:'700px'},{'margin-top':'0px'}]">
            <div class="border_top_left"></div>
            <div class="border_top_right"></div>
            <div class="border_bottom_left"></div>
            <div class="border_bottom_right"></div>
            <div class="h_light_right" :style="{top:'95px'}"></div>
            <div class="information_content issue_search_box model">
              <h1>
                添加任务
              </h1>
              <div style="padding-left: 90px;">
                <div style="color:white;padding-top: 10px;">
                  <div>任务名称</div> <el-input v-model="taskName" placeholder="请输入任务名称" style="width: 200px;" size="mini"></el-input>
                </div>
                <div style="color:white;position: absolute;left: 400px;top: 91px;">
                  <div>创建者</div> <el-input v-model="taskMan" placeholder="请输入创建者" style="width: 200px;" size="mini"></el-input>
                </div>
                <div style="color: white;padding-top: 0px;">
                  <div>
                    周期类型
                  </div>
                  <el-select v-model="Cycletype" placeholder="请选择" style="width: 490px;padding-top: 0px;height: 28px;" @change="giveCycletypeValue1(),giveCycletypeValue2()" size="mini">
                    <el-option
                      v-for="item in CycletypeValue"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <div class="cycle" style="width：600px;padding-top: 20px;">
                    <div><input id="LampWeekAll" type="checkbox" value="1,2,3,4,5,6,7" v-model="limit_weekday">全部</div>
                    <div><input type="checkbox" name="limit_weekday" value="1" v-model="limit_weekday">星期一</div>
                    <div><input type="checkbox" name="limit_weekday" value="2" v-model="limit_weekday">星期二</div>
                    <div><input type="checkbox" name="limit_weekday" value="3" v-model="limit_weekday">星期三</div>
                    <div><input type="checkbox" name="limit_weekday" value="4" v-model="limit_weekday">星期四</div>
                    <div><input type="checkbox" name="limit_weekday" value="5" v-model="limit_weekday">星期五</div>
                    <div><input type="checkbox" name="limit_weekday" value="6" v-model="limit_weekday">星期六</div>
                    <div><input type="checkbox" name="limit_weekday" value="7" v-model="limit_weekday">星期日</div>
                  </div>
                </div>
                <div style="color: white;">
                  <div>
                    <div>
                      开始日期
                    </div>
                    <el-date-picker
                      v-model="startDate"
                      type="date"
                      placeholder="选择日期"
                      style="width: 200px;height: 28px;" size="mini">
                    </el-date-picker>
                  </div>
                  <div style="position: relative;left: 290px;top: -53px;" >
                    <div>
                      结束日期
                    </div>
                    <el-date-picker
                      v-model="stopDate"
                      type="date"
                      placeholder="选择日期"
                      style="width: 200px;height: 28px;" size="mini">
                    </el-date-picker>
                  </div>
                </div>
                <div style="color: white;position: relative;top: -48px;" >
                  <div>
                    执行时间
                  </div>
                  <el-time-picker
                    arrow-control
                    v-model="timeChoice"
                    placeholder="任意时间点"
                    style="width: 490px;height: 28px;" size="mini">
                  </el-time-picker>
                </div>
                <div style="color: white;position: relative;top: -45px;">
                  <div>
                    任务音量微调
                  </div>
                  <el-select v-model="TaskVoiceControl" placeholder="请选择" style="width: 200px;padding-top: 0px;height: 28px;" size="mini">
                    <el-option
                      v-for="item in TaskVoiceControlValue"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
                <div style="color: white;position: relative;top: -40px;">
                  <div>
                    广播级别（0最低，15最高）
                  </div>
                  <el-select v-model="TaskVoiceLevel" placeholder="请选择" style="width: 200px;padding-top: 0px;height: 28px;" size="mini">
                    <el-option
                      v-for="item in TaskVoiceLevelValue"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <div style="position: relative;left: 290px;top: -54px;">
                    <div>
                      播放模式（持续时间自定义有效）
                    </div>
                    <el-select v-model="TaskPlayType" placeholder="请选择" style="width: 200px;padding-top: 0px;height: 28px;" size="mini">
                      <el-option
                        v-for="item in TaskPlayTypeValue"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div style="color: white;position: relative;top: -90px">
                  <div>
                    持续时间
                  </div>
                  <el-select v-model="TaskKeepTime" placeholder="请选择" style="width: 200px;padding-top: 0px;height: 28px;" @change="giveTaskKeepTimeValue()" size="mini">
                    <el-option
                      v-for="item in TaskKeepTimeValue"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value" >
                    </el-option>
                  </el-select>
                  <span id="zidingyi">
                    <el-input v-model="Hour"  style="width: 50px;padding-left: 50px;" size="mini"></el-input>
                    <span style="color: white;padding-top: 5px;padding-left: 5px;">时</span>
                    <el-input v-model="Minute"  style="width: 50px;padding-left: 10px;" size="mini"></el-input>
                    <span style="color: white;padding-top: 5px;padding-left: 5px;">分</span>
                    <el-input v-model="Second"  style="width: 50px;padding-left: 10px;" size="mini"></el-input>
                    <span style="color: white;padding-top: 5px;padding-left: 5px;">秒</span>
                  </span>
                </div>
                <div style="color: white;position: relative;top: -70px;left: -150px;">
                  <button :class='["add_btn","add","clearborder"]' style="width: 200px;" @click="SoundPlayer=!SoundPlayer"><span class="el-icon-plus"></span>设备选择</button>
                  <button :class='["add_btn","add","clearborder"]' style="width: 200px;position: relative;right: 70px;" @click="PlayerFile=!PlayerFile"><span class="el-icon-plus"></span>媒体文件列表</button>
                </div>
              </div>
              </div>
              <div class="sbt_box" style="position: relative;top: -40px;">
                <button :class='["add_btn","delete","icon_btn","clearborder"]'  @click="addtrigger=!addtrigger,cleanAddTrigger()">关闭</button>
                <button :class='["add_btn","add","icon_btn","clearborder"]' @click="addTrigger(),addtrigger=!addtrigger,cleanAddTrigger()">提交</button>
              </div>
            </div>
          </div>
      </transition>



      <!--  修改任务-->
      <transition name="fade">
        <div class="mark" v-if="loudEdit">
          <div class="mark_close" @click="loudEdit=!loudEdit"></div>
          <div :class='["information_box","light_border","weather_box"]'
               :style="[{width:'700px'},{'margin-top':'0px'}]">
            <div class="border_top_left"></div>
            <div class="border_top_right"></div>
            <div class="border_bottom_left"></div>
            <div class="border_bottom_right"></div>
            <div class="h_light_right" :style="{top:'95px'}"></div>
            <div class="information_content issue_search_box model">
              <h1>
                修改任务
              </h1>
              <div style="padding-left: 90px;">
                <div style="color:white;padding-top: 10px;">
                  <div>任务名称</div> <el-input v-model="taskName" placeholder="请输入任务名称" style="width: 200px;" size="mini"></el-input>
                </div>
                <div style="color:white;position: absolute;left: 400px;top: 91px;">
                  <div>创建者</div> <el-input v-model="taskMan" placeholder="请输入创建者" style="width: 200px;" size="mini"></el-input>
                </div>
                <div style="color: white;padding-top: 0px;">
                  <div>
                    周期类型
                  </div>
                  <el-select v-model="Cycletype" placeholder="请选择" style="width: 490px;padding-top: 0px;height: 28px;" @change="giveCycletypeValue1(),giveCycletypeValue2()" size="mini">
                    <el-option
                      v-for="item in CycletypeValue"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <div class="cycle" style="width：600px;padding-top: 20px;">
                    <div><input type="checkbox" value="1,2,3,4,5,6,7" v-model="limit_weekday">全部</div>
                    <div><input type="checkbox" name="limit_weekday" value="1" v-model="limit_weekday">星期一</div>
                    <div><input type="checkbox" name="limit_weekday" value="2" v-model="limit_weekday">星期二</div>
                    <div><input type="checkbox" name="limit_weekday" value="3" v-model="limit_weekday">星期三</div>
                    <div><input type="checkbox" name="limit_weekday" value="4" v-model="limit_weekday">星期四</div>
                    <div><input type="checkbox" name="limit_weekday" value="5" v-model="limit_weekday">星期五</div>
                    <div><input type="checkbox" name="limit_weekday" value="6" v-model="limit_weekday">星期六</div>
                    <div><input type="checkbox" name="limit_weekday" value="7" v-model="limit_weekday">星期日</div>
                  </div>
                </div>
                <div style="color: white;">
                  <div>
                    <div>
                      开始日期
                    </div>
                    <el-date-picker
                      v-model="startDate"
                      type="date"
                      placeholder="选择日期"
                      style="width: 200px;" size="mini">
                    </el-date-picker>
                  </div>
                  <div style="position: relative;left: 290px;top: -53px;" >
                    <div>
                      结束日期
                    </div>
                    <el-date-picker
                      v-model="stopDate"
                      type="date"
                      placeholder="选择日期"
                      style="width: 200px;" size="mini">
                    </el-date-picker>
                  </div>
                </div>
                <div style="color: white;position: relative;top: -48px;">
                  <div>
                    执行时间
                  </div>
                  <el-time-picker
                    arrow-control
                    v-model="timeChoice"
                    placeholder="任意时间点"
                    style="width: 490px;height: 28px;" size="mini">
                  </el-time-picker>
                </div>
                <div style="color: white;position: relative;top: -45px;">
                  <div>
                    任务音量微调
                  </div>
                  <el-select v-model="TaskVoiceControl" placeholder="请选择" style="width: 200px;padding-top: 0px;height: 28px;" size="mini">
                    <el-option
                      v-for="item in TaskVoiceControlValue"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
                <div style="color: white;position: relative;top: -40px;">
                  <div>
                    广播级别（0最低，15最高）
                  </div>
                  <el-select v-model="TaskVoiceLevel" placeholder="请选择" style="width: 200px;padding-top: 0px;height: 28px;" size="mini">
                    <el-option
                      v-for="item in TaskVoiceLevelValue"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <div style="position: relative;left: 290px;top: -54px;">
                    <div>
                      播放模式（持续时间自定义有效）
                    </div>
                    <el-select v-model="TaskPlayType" placeholder="请选择" style="width: 200px;padding-top: 0px;height: 28px;" size="mini">
                      <el-option
                        v-for="item in TaskPlayTypeValue"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div style="color: white;position: relative;top: -90px">
                  <div>
                    持续时间
                  </div>
                  <el-select v-model="TaskKeepTime" placeholder="请选择" style="width: 200px;padding-top: 0px;height: 28px;" @change="giveTaskKeepTimeValue()" size="mini">
                    <el-option
                      v-for="item in TaskKeepTimeValue"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value" >
                    </el-option>
                  </el-select>
                  <span id="zidingyi">
                    <el-input v-model="Hour"  style="width: 50px;padding-left: 50px;" size="mini"></el-input>
                    <span style="color: white;padding-top: 5px;padding-left: 5px;">时</span>
                    <el-input v-model="Minute"  style="width: 50px;padding-left: 10px;" size="mini"></el-input>
                    <span style="color: white;padding-top: 5px;padding-left: 5px;" >分</span>
                    <el-input v-model="Second"  style="width: 50px;padding-left: 10px;" size="mini"></el-input>
                    <span style="color: white;padding-top: 5px;padding-left: 5px;" >秒</span>
                  </span>
                </div>
                <div style="color: white;position: relative;top: -70px;left: -150px;">
                  <button :class='["add_btn","add","clearborder"]' style="width: 200px;" @click="SoundPlayer=!SoundPlayer"><span class="el-icon-plus"></span>设备选择</button>
                  <button :class='["add_btn","add","clearborder"]' style="width: 200px;position: relative;right: 70px;" @click="PlayerFile=!PlayerFile"><span class="el-icon-plus"></span>媒体文件列表</button>
                </div>
              </div>
            </div>
            <div class="sbt_box" style="position: relative;top: -40px;">
              <button :class='["add_btn","delete","icon_btn","clearborder"]'  @click="loudEdit=!loudEdit,cleanAddTrigger()">关闭</button>
              <button :class='["add_btn","add","icon_btn","clearborder"]' @click="changeGetTrigger()">提交</button>
            </div>
          </div>
        </div>
      </transition>



      <!--  媒体文件列表-->
      <transition name="fade">
        <div class="mark" v-if="PlayerFile">
          <div class="mark_close" @click="PlayerFile=!PlayerFile"></div>
          <div :class='["information_box","light_border","weather_box"]'
               :style="[{width:'1000px'},{'margin-top':'0px'}]">
            <div class="border_top_left"></div>
            <div class="border_top_right"></div>
            <div class="border_bottom_left"></div>
            <div class="border_bottom_right"></div>
            <div class="h_light_right" :style="{top:'95px'}"></div>
            <div class="information_content issue_search_box model">
              <!--table-->
              <div class="table_content" style="padding-top: 40px;">
                <table>
                  <thead>
                  <tr>
                    <th style="width: 50px !important;">
                      <input type="checkbox" name="issue_all" @click="ProgramCheckedAll()">
                    </th>
                    <th style="width: 100px !important;">序号</th>
                    <th>文件名</th>
                    <th>文件时长</th>
<!--                    <th>操作</th>-->
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(item,index) in resourcePageData">
                    <td style="width: 50px !important;">
                      <input type="checkbox" name="issue" v-model="selectedFile" :value="item.name">
                    </td>
                    <td>{{item.id}}</td>
                    <td>{{item.name}}</td>
                    <td>{{item.durations}}</td>
<!--                    <td class="table_btn">-->
<!--                      <button class="paly" style="margin-right: 20px">删除</button>-->
<!--                    </td>-->
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="sbt_box" style="padding-top: 30px;">
              <button :class='["add_btn","delete","icon_btn","clearborder"]'  @click="PlayerFile=!PlayerFile">关闭</button>
              <button :class='["add_btn","add","icon_btn","clearborder"]' @click="PlayerFile=!PlayerFile,getFileName()">提交</button>
            </div>
          </div>
        </div>
      </transition>


      <!--  设备列表-->
      <transition name="fade">
        <div class="mark" v-if="SoundPlayer">
          <div class="mark_close" @click="SoundPlayer=!SoundPlayer"></div>
          <div :class='["information_box","light_border","weather_box"]'
               :style="[{width:'600px'},{'margin-top':'0px'}]">
            <div class="border_top_left"></div>
            <div class="border_top_right"></div>
            <div class="border_bottom_left"></div>
            <div class="border_bottom_right"></div>
            <div class="h_light_right" :style="{top:'95px'}"></div>
            <div class="information_content issue_search_box model">
              <!--table-->
              <div class="table_content">
                <table>
                  <thead>
                  <tr>
                    <th style="width: 50px !important;">
                      <input type="checkbox" name="issue_all" />
                    </th>
                    <th>设备ID</th>
                    <th>设备名称</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(item,index) in devicePageData" v-bind:key="index">
                    <td style="width: 50px !important;">
                      <input type="checkbox" name="issue" v-model="selectedDevices" :value="item.device_id"/>
                    </td>
                    <td>{{item.device_id}}</td>
                    <td>{{item.name}}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="sbt_box" style="padding-top: 30px;">
              <button :class='["add_btn","delete","icon_btn","clearborder"]'  @click="SoundPlayer=!SoundPlayer">关闭</button>
              <button :class='["add_btn","add","icon_btn","clearborder"]' @click="SoundPlayer=!SoundPlayer,getDevicesName()">提交</button>
            </div>
          </div>
        </div>
      </transition>


    </div>
</template>

<script>
    export default {
        name: "equipment_management",
      data() {
        return {
          limit_weekday:[],
          PlayerFile:false,
          SoundPlayer:false,
          selectedDevices:[],
          startDate:'',
          stopDate:'',
          Hour:'',
          Minute:'',
          Second:'',
          CycletypeValue:[
            {
              value: '0',
              label: '每天'
            },
            {
              value: '1',
              label: '单周'
            },
            {
              value: '2',
              label: '单次'
            }
          ],
          TaskVoiceControlValue:[
            {
              value: '-5',
              label: '-5'
            },
            {
              value: '-4',
              label: '-4'
            },
            {
              value: '-3',
              label: '-3'
            },
            {
              value: '-2',
              label: '-2'
            },
            {
              value: '-1',
              label: '-1'
            },
            {
              value: '0',
              label: '0'
            },
            {
              value: '1',
              label: '1'
            },
            {
              value: '2',
              label: '2'
            },
            {
              value: '3',
              label: '3'
            },
            {
              value: '4',
              label: '4'
            },
            {
              value: '5',
              label: '5'
            },
          ],
          TaskVoiceLevelValue:[
            {
              value: '0',
              label: '0'
            },
            {
              value: '1',
              label: '1'
            },
            {
              value: '2',
              label: '2'
            },
            {
              value: '3',
              label: '3'
            },
            {
              value: '4',
              label: '4'
            },
            {
              value: '5',
              label: '5'
            },
            {
              value: '6',
              label: '6'
            },
            {
              value: '7',
              label: '7'
            },
            {
              value: '8',
              label: '8'
            },
            {
              value: '9',
              label: '9'
            },
            {
              value: '10',
              label: '10'
            },
            {
              value: '11',
              label: '11'
            },
            {
              value: '12',
              label: '12'
            },
            {
              value: '13',
              label: '13'
            },
            {
              value: '14',
              label: '14'
            },
            {
              value: '15',
              label: '15'
            },
          ],
          TaskPlayTypeValue:[
            {
              value: '0',
              label: '顺序播放'
            },
            {
              value: '1',
              label: '随机播放'
            },
          ],
          TaskKeepTimeValue:[
            {
              value: '0',
              label: '播放一遍'
            },
            {
              value: '1',
              label: '自定义'
            },
          ],
          soundPlayerValue:[],
          soundPlayer:'',
          TaskKeepTime:'',
          TaskVoiceControl:'',
          TaskVoiceLevel:'',
          TaskPlayType:'',
          timeChoice:'',
          dateChoice:'',
          Cycletype:'',
          taskName:'',
          taskMan:'',
          addtrigger:false,
          loudEdit:false,
          descriptiondata:[],
          Switch:true,
          search: [
            {
              title: '选择项目',
              options: [],
            },
          ],
          selectValue:'17e3b71e-b460-498e-b0ef-657d20bd6549',
          projectList:[],
          data: [],
          handdata:[],
          devicePageData:[],
          resourcePageData:[],
          selectedFile:[],
          filename:'',
          devicename:'',
          taskId:'',
          ProgramIsCheckedAll:false,
        }
      },
      methods:{
        InitLeftMenu: function () {
          this.$emit('getMessage', '5', '2');
        },

        ProgramCheckedAll() {
          this.ProgramIsCheckedAll = !this.ProgramIsCheckedAll
          if (this.ProgramIsCheckedAll) {
            // 全选时
            this.program_id = [];
            this.tabledata.forEach(function (tabledata) {
              this.program_id.push(tabledata.id.toString())
            }, this)
            $('input[name="program"]').each(function () {
              $(this).prop("checked", true);
            });
          } else {
            this.program_id = [];
            $('input[name="program"]').each(function () {
              $(this).prop("checked", false);
            });
          }
        },


        //获取项目列表
        getProjectList:function(){
          fetch("/api/v1/project/list", {
            method: 'post',
            body: JSON.stringify({

            })
          })
            .then(result => {
              return result.json();//解析流
            })
            //.then(data => console.log(data))
            .then(data => {
              if (data.code == "200") {
                this.message = "项目数据获取成功";
                this.projectList = data.data;
                let options = this.search[0].options;
                for (let i=0;i<this.projectList.length;i++){
                  let projectObj = {};
                  projectObj.label = this.projectList[i].name;
                  projectObj.value = this.projectList[i].id;
                  options.push(projectObj);
                };
              } else {
                this.message = "数据更新异常，请重试";
              }
            })
            .catch((error) => {
              this.message = "网络异常，请重试";
              this.msg_show = !this.msg_show;
            });
        },


        getFileName:function(){
          this.filename=this.selectedFile.join(",");
          //alert(this.filename);
        },

        getDevicesName:function(){
          this.devicename=this.selectedDevices.join("<");
          //alert(this.dateChoice);
          //alert(this.devicename);
        },


        getResourceList: function () {
          fetch("/api/v1/sounder/material/list", {
            method: 'post',
            body: JSON.stringify({
              "page_start": 0,
              "page_size": 10,
              "project": this.selectValue
            })
          }).then(result => {
            return result.json();//解析流
          }).then(data => {
            if (data.code == "200") {
              this.resourcePageData = data.data;
            }
          }).catch((error) => {
            console.log(error);
          });
        },


        getDeviceList: function () {
          fetch("/api/v1/sounder/plan/device/list", {
            method: 'post',
            body: JSON.stringify({
              project: this.selectValue,
              page_start: '0',
              page_size: '10',
            })
          }).then(result => {
            return result.json();//解析流
          }).then(data => {
            if (data.code == "200") {
              this.devicePageData = data.sound;
              for (let i=0;i<this.devicePageData.length;i++){
                let obj = {};
                obj.value =  this.devicePageData[i].device_id;
                obj.label = this.devicePageData[i].name;
                this.soundPlayerValue.push(obj);
              };

            }
          }).catch((error) => {
            console.log(error);
          });
        },

        parseDate: function (date, flag) {
          if(typeof(this.timeChoice)=='string'){
            this.timeChoice=this.choiceTime;
          }
          if(typeof(date)=='string'){
            return date;
          }else {
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? ('0' + m) : m;
            var d = date.getDate();
            d = d < 10 ? ('0' + d) : d;
            var h = date.getHours();
            var minute = date.getMinutes();
            minute = minute < 10 ? ('0' + minute) : minute;
            var second= date.getSeconds();
            second = minute < 10 ? ('0' + second) : second;
            if(flag){
              return y + '-' + m + '-' + d;
            }else {
              return h+':'+minute+':'+ second;
            }
          }
        },

        //重置添加
        cleanAddTrigger:function(){
            this.taskName='',
            this.taskMan='',
            this.TaskVoiceControl='',
            this.TaskPlayType='',
            this.TaskVoiceLevel='',
            this.startDate='',
            this.stopDate='',
            this.timeChoice='',
            this.Cycletype='',
            this.limit_weekday=[],
            this.Hour='',
            this.Minute='',
            this.Second='',
            this.filename='',
            this.devicename='',
            this.TaskKeepTime=''
        },


        changeGetTrigger:function(){
          if(this.filename==''||this.devicename==''){
            alert("请重新选择媒体文件或播放设备！");
          }else {
            this.changeTrigger();
          }
        },


        //修改定时任务
        changeTrigger:function(){
          fetch("/api/v1/sounder/plan/editor", {
            method: 'post',
            body: JSON.stringify({
              "taskname": this.taskName,
              "creator": this.taskMan,
              "fine_tuning":this.TaskVoiceControl+"",
              "play_way": this.TaskPlayType,
              "level": this.TaskVoiceLevel,
              "project": this.selectValue,
              "start_date": this.parseDate(this.startDate,true),
              "end_date": this.parseDate(this.stopDate,true),
              "start_time": this.parseDate(this.timeChoice,false),
              "play_type": this.Cycletype,
              "weekend": this.limit_weekday.join(","),
              "durations": parseInt(this.Hour)*60*60+parseInt(this.Minute)*60+parseInt(this.Second)+0+"",
              "filename": this.filename,
              "device_id": this.devicename,
              "task_id":this.taskId,
            })
          })
            .then(result => {
              return result.json();//解析流
            })
            .then(data => {
              if (data.code == "200") {
                this.message = "定时任务修改成功";
                this.msg_show = !this.msg_show;
                this.loudEdit=!this.loudEdit;
                alert(this.message);
                this.timer = setTimeout(this.ListData, 1000);
                this.cleanAddTrigger();
              } else {
                this.message = "操作异常，请重试";
                this.msg_show = !this.msg_show;
                alert(this.message);
              }
            })
            .catch((error) => {
              this.message = "网络连接异常，请重试";
              this.msg_show = !this.msg_show;
              alert(this.message);
              throw error;
            });

        },


        //添加定时任务
        addTrigger:function(){
          fetch("/api/v1/sounder/plan/add", {
            method: 'post',
              body: JSON.stringify({
                "taskname": this.taskName,
                "creator": this.taskMan,
                "fine_tuning":this.TaskVoiceControl+"",
                "play_way": this.TaskPlayType,
                "level": this.TaskVoiceLevel,
                "project": this.selectValue,
                "start_date": this.parseDate(this.startDate,true),
                "end_date": this.parseDate(this.stopDate,true),
                "start_time": this.parseDate(this.timeChoice,false),
                "play_type": this.Cycletype,
                "weekend": this.limit_weekday.join(','),
                "durations": parseInt(this.Hour)*60*60+parseInt(this.Minute)*60+parseInt(this.Second)+0+"",
                "filename": this.filename,
                "device_id": this.devicename,
            })
          })
            .then(result => {
              return result.json();//解析流
            })
            .then(data => {
              if (data.code == "200") {
                this.message = "定时任务添加成功";
                this.msg_show = !this.msg_show;
                alert(this.message);
                this.timer = setTimeout(this.ListData, 1000);
              } else {
                this.message = "操作异常，请重试";
                this.msg_show = !this.msg_show;
                alert(this.message);
              }
            })
            .catch((error) => {
              this.message = "网络连接异常，请重试";
              this.msg_show = !this.msg_show;
              alert(this.message);
              throw error;
            });

        },

        giveTaskKeepTimeValue:function(){
          if(this.TaskKeepTime==1){
            $("#zidingyi").css("display","flex");
          }else {
            $("#zidingyi").css("display","none");
          }
        },

        // giveCycletypeValue2:function(){
        //   if(this.Cycletype==2){
        //     $(".jeishushijian").css("display","none");
        //   }else {
        //     $(".jeishushijian").css("display","flex");
        //   }
        // },

        giveCycletypeValue1:function(){
          if(this.Cycletype==1){
            $(".cycle").css("display","flex");
          }else {
            $(".cycle").css("display","none");
          }
        },

        //列表获取
        ListData:function(){
          fetch("/api/v1/sounder/plan/list", {
            method: 'post',
            body: JSON.stringify({
              "project": this.selectValue,
              "page_start": 0,
              "page_size": 10,
            })
          })
            .then(result => {
              return result.json();//解析流
            })
            //.then(data => console.log(data))
            .then(data => {
              if (data.code == "200") {
                this.message = "实时数据更新成功";
                this.refresh = true;
                this.msg_show = !this.msg_show;
                this.data = data.tasks;
                for (let i=0;i<this.data.length;i++){
                  let descriptionArr = this.data[i].description.split("|");
                  this.data[i]["timing"] = descriptionArr[0];
                  this.data[i]["cycleType"] = descriptionArr[1];
                  this.data[i]["startDate"] = descriptionArr[2];
                  this.data[i]["endDate"] = descriptionArr[3];
                  this.data[i]["executionDate"] = descriptionArr[4];
                  this.data[i]["week"] = descriptionArr[5];
                };
                console.log(this.data);
                //this.Switch = data.data.lamp.status;
              } else {
                this.message = "数据更新异常，请重试";
                this.msg_show = !this.msg_show;
              }
            })
            .catch((error) => {
              this.message = "网络异常，请重试";
              this.msg_show = !this.msg_show;
            });
        },


        //启用关闭
        openClose($event,id){
          if($event=='0') {
            this.CloseLoud_sbt(id);
            console.log("关闭");
          }else {
            console.log("打开")
            this.OpenLoud_sbt(id);

          }
          console.log($event);
        },

        //启用关闭
        handController($event,id){
          if($event=='0') {
            this.handCloseLoud_sbt(id);
            console.log("关闭");
          }else {
            console.log("打开")
            this.handOpenLoud_sbt(id);

          }
          console.log($event);
        },


        //回显任务
        getTask:function(id){
          this.taskId=id;
          fetch("/api/v1/sounder/plan/echo",{
            method: 'post',
            body: JSON.stringify({
              "task_id": id,
            })
          })
            .then(result => {
              return result.json();//解析流
            })
            //.then(data => console.log(data))
            .then(data => {
              if (data.code == "200") {
                this.message = "实时数据更新成功";
                this.msg_show = !this.msg_show;
                if(data.tasks.commands[0].durations=='0'){
                  this.TaskKeepTime='0';
                }else {
                  this.TaskKeepTime='1';
                };
                  this.taskName=data.tasks.name;
                  this.taskMan=data.tasks.createUser;
                  this.TaskVoiceControl='0';
                  this.TaskPlayType=data.tasks.commands[0].israndom;
                  this.TaskVoiceLevel=data.tasks.taskLevel;
                  this.startDate=data.tasks.triggers[0].startdate;
                  this.stopDate=data.tasks.triggers[0].enddate;
                  this.timeChoice="2019-01-01 "+data.tasks.triggers[0].starttime;
                  this.choiceTime=data.tasks.triggers[0].starttime;
                  this.Cycletype=data.tasks.triggers[0].scheduletype;
                  this.limit_weekday=data.taskstriggers[0].weekday;
                  this.Hour=data.tasks.commands[0].Hour;
                  this.Minute=data.tasks.commands[0].Minute;
                  this.Second=data.tasks.commands[0].Second;
                  this.filename=data.tasks.commands[0].file_name;
                  this.devicename=data.tasks.commands[0].target;
                  this.giveCycletypeValue();
              } else {
                this.message = "数据更新异常，请重试";
                this.msg_show = !this.msg_show;
              }
            })
            .catch((error) => {
              this.message = "网络异常，请重试";
              this.msg_show = !this.msg_show;
            });
        },


        //开启
        OpenLoud_sbt: function (id) {
          fetch("/api/v1/sounder/plan/start/stop", {
            method: 'post',
            body: JSON.stringify({
              "isdisable": "1",
              "taskid": id,
            })
          })
            .then(result => {
              return result.json();//解析流
            })
            .then(data => {
              if (data.code == "200") {
                this.message = "开启成功";
                this.Open = !this.Open;
                this.refresh = true;
                this.msg_show = !this.msg_show;
                alert(this.message);
                this.timer = setTimeout(this.ListData, 1000);
              } else {
                this.message = "操作异常，请重试";
                this.Open = !this.Open;
                this.msg_show = !this.msg_show;
                alert(this.message);
              }
            })
            .catch((error) => {
              this.message = "网络连接异常，请重试";
              this.Open = !this.Open;
              this.msg_show = !this.msg_show;
              alert(this.message);
              throw error;
            });
        },



        //关闭
        CloseLoud_sbt: function (id) {
          fetch("/api/v1/sounder/plan/start/stop", {
            method: 'post',
            body: JSON.stringify({
              "isdisable": "0",
              "taskid": id,
            })
          })
            .then(result => {
              return result.json();//解析流
            })
            .then(data => {
              if (data.code == "200") {
                this.message = "关闭成功";
                this.Close = !this.Close;
                this.refresh = true;
                this.msg_show = !this.msg_show;
                alert(this.message);
                this.timer = setTimeout(this.ListData, 1000);
              } else {
                this.message = "操作异常，请重试";
                this.Close = !this.Close;
                this.msg_show = !this.msg_show;
                alert(this.message);
              }
            })
            .catch((error) => {
              this.message = "网络连接异常，请重试";
              this.Close = !this.Close;
              this.msg_show = !this.msg_show;
              alert(this.message);
              throw error;
            });
        },


        //手动开启
        handOpenLoud_sbt: function (id) {
          fetch("/api/v1/sounder/plan/start", {
            method: 'post',
            body: JSON.stringify({
              "task_id": id,
            })
          })
            .then(result => {
              return result.json();//解析流
            })
            .then(data => {
              if (data.code == "200") {
                this.message = "手动开启成功";
                this.Open = !this.Open;
                this.refresh = true;
                this.msg_show = !this.msg_show;
                alert(this.message);
                this.timer = setTimeout(this.ListData, 1000);
              } else {
                this.message = "操作异常，请重试";
                this.Open = !this.Open;
                this.msg_show = !this.msg_show;
                alert(this.message);
              }
            })
            .catch((error) => {
              this.message = "网络连接异常，请重试";
              this.Open = !this.Open;
              this.msg_show = !this.msg_show;
              alert(this.message);
              throw error;
            });
        },



        //关闭
        handCloseLoud_sbt: function (id) {
          fetch("/api/v1/sounder/plan/stop", {
            method: 'post',
            body: JSON.stringify({
              "task_id": id,
            })
          })
            .then(result => {
              return result.json();//解析流
            })
            .then(data => {
              if (data.code == "200") {
                this.message = "关闭成功";
                this.Close = !this.Close;
                this.refresh = true;
                this.msg_show = !this.msg_show;
                alert(this.message);
                this.timer = setTimeout(this.ListData, 1000);
              } else {
                this.message = "操作异常，请重试";
                this.Close = !this.Close;
                this.msg_show = !this.msg_show;
                alert(this.message);
              }
            })
            .catch((error) => {
              this.message = "网络连接异常，请重试";
              this.Close = !this.Close;
              this.msg_show = !this.msg_show;
              alert(this.message);
              throw error;
            });
        },


        //删除任务
        deleteTask: function (id) {
          fetch("/api/v1/sounder/plan/delete", {
            method: 'post',
            body: JSON.stringify({
              "task_id": [id],
            })
          })
            .then(result => {
              return result.json();//解析流
            })
            .then(data => {
              if (data.code == "200") {
                this.message = "删除成功";
                this.refresh = true;
                this.msg_show = !this.msg_show;
                alert(this.message);
                this.timer = setTimeout(this.ListData, 1000);
              } else {
                this.message = "操作异常，请重试";
                this.msg_show = !this.msg_show;
                alert(this.message);
              }
            })
            .catch((error) => {
              this.message = "网络连接异常，请重试";
              this.msg_show = !this.msg_show;
              alert(this.message);
              throw error;
            });
        },


      },
      created() {
        this.InitLeftMenu();
        this.getProjectList();
        this.ListData();
        this.getDeviceList();
        this.getResourceList();
      }
    }
</script>

<style scoped>
  .equipment_management{
    width: 100%;
    height: 100%;
    padding: 0 20px;
    box-sizing: border-box;
  }

  .search {
    width: 100%;
    height: 100px;
    padding: 20px 0px 0px;
  }

  .search_box {
    width: 100%;
    height: 100%;
    margin-right: 10px;
    background: #16518d;
    border-radius: 6px;
    float: left;
    display: flex;
    align-items: center;
    padding: 0 10px;
    box-sizing: border-box;
    position: relative;
  }

  .search_options_box {
    width: 16%;
    padding: 0 10px;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .search_options_box > span {
    width: 64px;
    margin-right: 8px;
    text-align: right;
    color: #FFFFFF;
  }

  .search_options_box > select {
    width: calc(100% - 72px);
    height: 36px;
    border-radius: 6px;
    background: transparent;
    border: 1px solid #ffffff;
    color: #ffffff;
    appearance: none;
    padding-left: 10px;
    font-size: 16px;
    outline: none;
    cursor: pointer;
  }

  .search_options_box option {
    color: #000000;
  }

  .search_options_box > img {
    position: absolute;
    top: 48px;
    right: 20px;
    cursor: pointer;
  }

  .search_btn_box {
    width: 80px;
    padding: 10px;
  }

  .clearborder {
    outline: none;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .search_btn {
    width: 100%;
    height: 32px;
    border-radius: 6px;
    line-height: 32px;
  }

  .add_btn {
    width: 110px;
    height: 32px;
    border-radius: 6px;
    line-height: 32px;
    float: right;
    margin-right: 20px;
  }

  .icon_btn span {
    margin-right: 8px;
  }

  .green {
    background: #21b868;
    color: #FFFFFF;
  }

  .green:active {
    background: #15a95a;
  }

  .blue {
    background: #7aafeb;
    color: #FFFFFF;
  }

  .blue:active {
    background: #4699f7;
  }

  .yellow {
    background: #f2ae4d;
    color: #FFFFFF;
  }

  .yellow:active {
    background: #fa9b15;
  }


  .add_btn_box {
    /*width: 370px;*/
    padding: 10px;
    position: absolute;
    right: 0px;
  }

  .add {
    background: #7aafeb;
    color: #FFFFFF;
    box-shadow: 0 3px 0 #3574ba;
  }

  .add:active {
    background: #6ca3e2;
  }

  .publish {
    background: #21b868;
    color: #FFFFFF;
    box-shadow: 0 3px 0 #188d4f;
  }

  .publish:active {
    background: #188d4f;
  }

  .delete {
    background: #f2ae4d;
    color: #FFFFFF;
    box-shadow: 0px 3px 0px #dc8509;
  }

  .delete:active {
    background: #e7a342;
  }

  .table_content {
    width: 100%;
    /* height: calc(100% - 100px);*/
    padding: 20px 0px;
  }

  .table_content > table {
    width: 100%;
    height: 100%;
    border: 1px solid #094b8e;
    background-color: #16518d;
  }

  .table_content > table tr th {
    background-color: #0e345b;
  }

  .table_content > table tr td {
    /*background-color: #16518d;*/
  }

  .table_content > table input {
    width: 16px;
    height: 16px;
  }

  .table_content > table tr:nth-child(2n) {
    background-color: #11406f;
  }

  .table_content > table tr {
    /*border-bottom: 1px solid #225892;*/
    height: 62px
  }

  .table_content > table tr td, .table_content > table tr th {
    text-align: center;
    color: #FFFFFF;
  }

  .table_content > table tr th select {
    background: transparent;
    color: #FFFFFF;
    border: none;
    outline: none;

  }

  .table_content > table tr th select option {
    color: #333333;

  }

  .table_paging {
    height: 60px;
    width: 100%;
    display: flex;
    align-items: center;
    border: 1px solid #105ba8;
    border-radius: 6px;
  }

  .table_paging > p {
    width: 100%;
    height: 30px;
    line-height: 30px;
    text-align: right;
    margin-bottom: 0;
    color: #c1c2c6;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 10px;
  }

  .table_paging > p > button {
    margin: 0 8px;
    width: 10px;
    height: 16px;
    border: none;
    outline: none;
  }

  .table_btn>button {
    color: #95bee5;
    background: transparent;
    border: 1px solid #95bee5;
    outline: transparent;
    padding: 5px 20px;
    border-radius: 6px;
  }

  #zidingyi{
    display: none;
    position: relative;
    left: 240px;
    top: -25px;
  }

  /*#jeishushijian{*/
  /*  display: flex;*/
  /*}*/

  .cycle{
    display: none;
    color: #ffffff;
    flex-wrap: wrap;
    width: calc(100% - 160px);
    margin-left: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/03Monitoring/6_loudspeaker/equipment_management.vue